import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./LeadCommentModelCss.css";
import CommentBox from "./CommentBox";
import axios from "axios";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import { AllLeadUserComments } from "../../FetchAPI";
import { useAuth } from "../../../Store/AuthContext";
import { Checkbox } from "@mui/material";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadCommentModel({ open, handleClose, leadID }) {
  const { userID, RendomTokenfetch, userRoll } = useAuth();

  const [fetchComment, setfetchComment] = useState([]);

  const [Comment, setComment] = useState("");
  const [showToUser, setShowToUser] = useState(false);

  const fetchData = useCallback(async () => {
    const data = await AllLeadUserComments(RendomTokenfetch, leadID);
    setfetchComment(data);
  }, [RendomTokenfetch, leadID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("leadid", leadID);
    fdata.append("role_id", userRoll);
    fdata.append("comment", Comment);
    fdata.append("show_to_vendor", "1");
    if (userRoll === "5") {
      fdata.append("show_to_user", "1");
    } else {
      fdata.append("show_to_user", showToUser ? "1" : "0");
    }

    axios
      .post(`${WebsiteAPIurl}leadCommentAdd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (Comment) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.msg, "danger");
          }
          if (response.data.Status === "1") {
            fetchData();
            NotifyMessageNoReload(response.data.msg, "success");
            setComment("");
            setShowToUser(false);
          }
        } else {
        }
      });
  };

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box className="CommentBoxModel">
          <div className="Commentheading">
            <h4>Recent Comments</h4>
            <button className="CloseModelbtn" onClick={handleClose}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          {/* <LeadCommentAddForm
            RendomTokenfetch={RendomTokenfetch}
            leadID={leadID}
          /> */}

          <div className="leadCommentaddbox">
            <form
              className="default-form "
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div className="row">
                <div className="form-group col-lg-12 col-md-12">
                  <label>Comments</label>
                  <textarea
                    value={Comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Add Comment"
                    rows={3}
                  />
                </div>
                <div
                  className={`col-lg-12 col-md-12  ${
                    userRoll === "5"
                      ? "text-end"
                      : "d-flex justify-content-between"
                  } mb-3`}
                >
                  <div
                    className={`showtousercheckbox ${
                      userRoll === "5" ? "d-none" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    <Checkbox
                      sx={{
                        "&.Mui-checked": {
                          color: "green",
                        },
                      }}
                      checked={showToUser}
                      onChange={() => setShowToUser((prev) => !prev)}
                    />
                    <span onClick={() => setShowToUser((prev) => !prev)}>
                      Show to User
                    </span>
                  </div>
                  <button className="theme-btn btn-style-three submitbtn">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="commentboxdiv">
            {fetchComment.length > 0 ? (
              fetchComment.map((value, index) => (
                <CommentBox key={index} value={value} />
              ))
            ) : (
              <div className="noCommnetLead">No Comments!</div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
